import { useUser } from '~/app/contexts/UserContext';

const CEO = 'CEO';

export function useIsCEO() {
  const { band } = useUser();

  return band === CEO;
}
